import React from 'react';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import {Button, DialogActions, Typography} from '@mui/material';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import {_theme} from '../_theme';
import {ThemeProvider} from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import {CheckCircle} from '@mui/icons-material';
import PropTypes from 'prop-types';
import {getIcon} from "../utils/_icons.jsx";

/**
 * Common base popup for the apps, based on the design proposed in the Risk&Crisis monitor tab
 * TODO use this template in the rest of the app
 *
 * @param {string} title
 * @param {JSX.Element} content
 * @param {JSX.Element} buttons
 * @param {function()} onClose
 * @param {boolean} [centerButtons=false]
 * @param {DialogProps} dialogProps
 * @return {JSX.Element}
 * @constructor
 */
export const BasePopup = ({title, content, buttons, onClose, centerButtons = false, dialogProps = {}}) => {
    return <ThemeProvider theme={_theme}>
        <Dialog
            onClose={onClose}
            open={true}
            {...dialogProps}
        >
            <DialogTitle className='datagrid-dialog-closeIconContainer'>
                <IconButton onClick={onClose}>
                    <CloseIcon fontSize='large' />
                </IconButton>
            </DialogTitle>
            {title &&
                <DialogTitle color='primary' variant='h5' className='base-popup-title-container'>
                    {title}
                </DialogTitle>
            }
            <DialogContent style={{padding: '12px 70px 60px 70px'}}>
                {content}
            </DialogContent>
            <DialogActions style={{ padding: '30px 50px', justifyContent: centerButtons ? 'space-around' : 'flex-end' }}>
                {buttons}
            </DialogActions>
        </Dialog>
    </ThemeProvider>;
};

BasePopup.propTypes = {
    title: PropTypes.string,
    content: PropTypes.element,
    buttons: PropTypes.element,
    onClose: PropTypes.func,
    centerButtons: PropTypes.bool,
    dialogProps: PropTypes.object,
};

/**
 * @param {string} text
 * @param {function()} onClose
 * @return {JSX.Element}
 * @constructor
 */
export const SuccessPopup = ({text, onClose}) => {

    return <BasePopup
        content={
            <div className='add-material-popup-success-container'>
                <CheckCircle fontSize='large' color='primary' sx={{fontSize: '80px !important'}} />
                <Typography variant='h4' color='primary'>
                    Success!
                </Typography>
                <Typography style={{color: '#656f71', fontSize: '16px', marginTop: '10px'}}>
                    {text}
                </Typography>
            </div>
        }
        buttons={
            <Button
                className='add-material-popup-button'
                variant='contained'
                onClick={onClose}
            >
                Ok
            </Button>
        }
        centerButtons={true}
        onClose={onClose}
    />;
};

SuccessPopup.propTypes = {
    text: PropTypes.string,
    onClose: PropTypes.func,
};

/**
 * @param {string} text
 * @param {string} title
 * @param {string} type
 * @param {function()} onClose
 * @return {JSX.Element}
 * @constructor
 */
export const SuccessErrorPopup = ({
  text,
  title,
  type = 'Success',
  onClose,
}) => {
  const isSuccess = type === 'Success';

  return (
    <BasePopup
      content={
        <div className='add-material-popup-success-container'>
          {getIcon(isSuccess ? 'CheckCircleIcon' : 'ErrorIcon', true, {
            style: {
              color: `${isSuccess ? '#F49C21' : '#ED2B4B'}`,
              position: 'relative',
              marginBottom: '20px',
            },
          })}
          <Typography
            variant='h3'
            align='center'
            color={`${isSuccess ? '#F49C21' : '#ED2B4B'}`}>
            {title}
          </Typography>
          <Typography
            style={{ color: '#656f71', fontSize: '16px', marginTop: '10px' }}>
            {text}
          </Typography>
        </div>
      }
      buttons={
        <Button
          className='add-material-popup-button'
          variant='contained'
          onClick={onClose}>
          Ok
        </Button>
      }
      centerButtons={true}
      onClose={onClose}
    />
  );
};

SuccessErrorPopup.propTypes = {
    text: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    onClose: PropTypes.func,
    dialogProps: PropTypes.object,
};
